import axios, { AxiosResponse } from 'axios';
import config from '@/config';
import { IEditImage } from '@/shared';
import { IUploadResponse } from '../interfaces/upload-response';
import { baseRequest } from './base-request';

export const uploadRequest = {
  get: async (clientKey: string, path?: string) => {
    const result = path
      ? await baseRequest.get(`${config?.uploader}${path}?clientKey=${clientKey}`)
      : await baseRequest.get(`${config?.uploader}/uploads?clientKey=${clientKey}`);
    return result;
  },

  getProtected: (
    clientKey: string,
    filename: string,
  ): Promise<AxiosResponse<Blob>> => axios.get(
    `${config?.uploader}/protected?clientKey=${clientKey}&filename=${filename}`,
    { responseType: 'blob' },
  ),

  delete: async <IExpectedResponse>(clientKey: string, path: string): Promise<IExpectedResponse | null> => {
    const res = await baseRequest.delete<IExpectedResponse>(`${config?.uploader}${path}?clientKey=${clientKey}`);
    return res;
  },

  post: (clientKey: string, type: string, formData: FormData, querystring: string = '') => baseRequest.post(
    `${config?.uploader}/uploads?clientKey=${clientKey}&type=${type}${querystring}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  ),

  postJSON: () => baseRequest.post(
    `${config?.uploader}/uploads`,
    {},
  ),
  put: (
    clientKey: string,
    type: string,
    filename: string,
    data: IEditImage[],
    makeNew?: boolean,
    querystring: string = '',
  ): Promise<IUploadResponse> => baseRequest.put(
    `${config?.uploader}/uploads?clientKey=${clientKey}&type=${type}&filename=${filename}&makeNew=${makeNew ? '1' : ''}${querystring}`,
    data,
  ),
};
